import { ControlPanel } from './components/ControlPanel.tsx';
import { MapInspector } from './components/MapInspector.tsx';
import { Viewer } from './components/Viewer.tsx';
import { useForgeStore } from './state/store.ts';
import { useViewStore, type Workspace } from './state/view.ts';
import { MapPanel, MapStage } from './components/MapForge.tsx';
import { TerrainPanel, TerrainStage } from './components/TerrainForge.tsx';
import { BlenderStudio } from './components/BlenderStudio.tsx';

const WORKSPACES: { id: Workspace; label: string }[] = [
  { id: 'character', label: '캐릭터' },
  { id: 'map', label: '맵' },
  { id: 'terrain', label: '지형' },
  { id: 'blender', label: 'Blender' },
];

function Brand() {
  const backend = useForgeStore((s) => s.backend);
  const effective = useForgeStore((s) => s.effectivePreset);
  const hasImage = useForgeStore((s) => Boolean(s.analysis));
  const workspace = useViewStore((s) => s.workspace);
  const setWorkspace = useViewStore((s) => s.setWorkspace);

  return (
    <header className="brand">
      <span className="dot" />
      <h1>Texel Forge</h1>
      <nav className="tabs" aria-label="작업대">
        {WORKSPACES.map((w) => (
          <button key={w.id} className="tab" aria-pressed={workspace === w.id} onClick={() => setWorkspace(w.id)}>{w.label}</button>
        ))}
      </nav>
      <span className="pill">{workspace === 'blender' ? 'Blender 로컬 제작 · 버전 보존' : '이미지 → 질감 있는 3D · 브라우저 제작'}</span>
      <span className="spacer" />
      {hasImage && workspace !== 'blender' && <span className="pill">{effective}</span>}
      <span className="pill live">{workspace === 'blender' ? 'GLB · PBR' : backend === 'onnx' ? 'ONNX 깊이' : '즉시 깊이'}</span>
      <span className="pill">WebGL2</span>
    </header>
  );
}

export function App() {
  const workspace = useViewStore((s) => s.workspace);
  return (
    <div className="app" data-workspace={workspace}>
      <Brand />
      {/* 캐릭터 작업대는 항상 마운트해 둔다 — 리그와 셰이더를 잃지 않으려고. 다른 작업대에서는 숨긴다. */}
      <div className="ws" hidden={workspace !== 'character'}>
        <ControlPanel />
        <Viewer />
        <MapInspector />
      </div>
      {workspace === 'map' && <><MapPanel /><MapStage /><aside className="inspector" /></>}
      {workspace === 'terrain' && <><TerrainPanel /><TerrainStage /><aside className="inspector" /></>}
      {workspace === 'blender' && <BlenderStudio />}
    </div>
  );
}
